import {
  USER_LOGIN,
  USER_FORGOT_PASSWORD,
  USER_RESET_PASSWORD,
  USER_LOGOUT,
  USER_PROFILE,
  USER_CHANGE_PASSWORD,
  ADMIN_CONTENT_DATA,
  ADMIN_USER_LIST,
  ADMIN_SEND_BROADCAST,
  ADMIN_BROADCAST_LIST,
  ADMIN_BROADCAST_DELETE,
  ADMIN_USER_DETAIL,
  ADMIN_USER_TESTIMONIALS,
  ADMIN_DASHBOARD,
  ADMIN_OPERATIONS_STATUS,
  ADMIN_OPERATIONS_RESTART,
  ADMIN_REFERRALS,
  ADMIN_PLAN_LIST,
  ADMIN_USER_SUBSCRIBE,
  ADMIN_BLOG_LIST,
  ADMIN_BLOG_CREATE,
  ADMIN_BLOG_DETAIL,
  ADMIN_BLOG_UPDATE,
  ADMIN_BLOG_DELETE,
  ADMIN_SUBSCRIPTION_LIST,
} from "./APIEndPoints";
import { getMethod, postMethod, putMethod, deleteMethod } from "./APIInstance";

//API: Login user
export const handleAdminLogin = async (data) => {
  try {
    const response = await postMethod(USER_LOGIN, data);
    return response;
  } catch (error) {
    // console.error("Getting error in admin login api", error);
  }
};

export const handleAdminForgotPassword = async (data) => {
  try {
    const response = await postMethod(USER_FORGOT_PASSWORD, data);
    return response;
  } catch (error) {
    // console.error("Getting error in forgot password api", error);
  }
};

export const handleAdminResetPassword = async (data) => {
  try {
    const response = await putMethod(USER_RESET_PASSWORD, data);
    return response;
  } catch (error) {
    // console.error("Getting error in admin reset password", error);
  }
};

export const handleAdminLogout = async () => {
  try {
    const response = await getMethod(USER_LOGOUT);
    return response;
  } catch (error) {
    // console.error("Getting error in admin logout", error);
  }
};

export const handleAdminFetchProfile = async () => {
  try {
    const response = await getMethod(USER_PROFILE);
    return response;
  } catch (error) {
    // console.error("Getting error in fetch admin profile", error);
  }
};

export const handleAdminUpdateProfile = async (data) => {
  try {
    const response = await putMethod(USER_PROFILE, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update admin profile api", error);
  }
};

export const handleAdminUpdatePassword = async (data) => {
  try {
    const response = await putMethod(USER_CHANGE_PASSWORD, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminFetchContent = async (data) => {
  try {
    const response = await getMethod(ADMIN_CONTENT_DATA, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminUpdateContent = async (data) => {
  try {
    const response = await putMethod(ADMIN_CONTENT_DATA, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminUserList = async (data) => {
  try {
    const response = await getMethod(ADMIN_USER_LIST, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleSubscriptionList = async (data) => {
  try {
    const response = await getMethod(ADMIN_SUBSCRIPTION_LIST, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminSendBroadcast = async (data) => {
  try {
    const response = await postMethod(ADMIN_SEND_BROADCAST, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminBroadcastList = async (data) => {
  try {
    const response = await getMethod(ADMIN_BROADCAST_LIST, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminDeleteBroadcast = async (data) => {
  try {
    const response = await deleteMethod(
      `${ADMIN_BROADCAST_DELETE}?id=${data.id}`
    );
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminUserDetail = async (data, id) => {
  try {
    const response = await getMethod(`${ADMIN_USER_DETAIL}/${id}`, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminUserTestimonialList = async (data, id) => {
  try {
    const response = await getMethod(`${ADMIN_USER_TESTIMONIALS}/${id}`, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update password", error);
  }
};

export const handleAdminDashboard = async () => {
  try {
    const response = await getMethod(ADMIN_DASHBOARD);
    return response;
  } catch (error) {}
};

export const handleAdminOperationsStatus = async () => {
  try {
    const response = await getMethod(ADMIN_OPERATIONS_STATUS);
    return response;
  } catch (error) {
    throw error;
  }
};

export const handleAdminOperationsRestart = async () => {
  try {
    const response = await postMethod(ADMIN_OPERATIONS_RESTART, {});
    return response;
  } catch (error) {
    throw error;
  }
};

export const handleAdminReferrals = async (params = {}) => {
  try {
    return await getMethod(ADMIN_REFERRALS, params);
  } catch (error) {
    throw error;
  }
};

export const handleAdminPlanList = async () => {
  try {
    const response = await getMethod(ADMIN_PLAN_LIST);
    return response;
  } catch (error) {
    // Handle or log error here if needed
  }
};

// Get subscription plan for a specific user
export const handleAdminUserPlan = async (userId) => {
  try {
    const response = await getMethod(ADMIN_PLAN_LIST, { userId });
    return response;
  } catch (error) {
    // You can log or handle error here
  }
};

export const handleAdminUserSubscribe = async (userId, planId) => {
  try {
    const formData = new FormData();
    formData.append("planId", planId);

    // Using postMethod wrapper that calls axios post with formData
    const response = await postMethod(ADMIN_USER_SUBSCRIBE(userId), formData);
    return response;
  } catch (error) {
    // Forward error for component to handle
    throw error;
  }
};

// Start of Blog APIs

export const handleAdminGetBlogs = async (data) => {
  try {
    const response = await getMethod(ADMIN_BLOG_LIST, data);
    console.log("Blog list response:", response);
    return response;
  } catch (error) {
    // console.error("Getting error in fetch blogs", error);
  }
};

export const handleAdminCreateBlog = async (data) => {
  try {
    const response = await postMethod(ADMIN_BLOG_CREATE, data);
    return response;
  } catch (error) {
    // console.error("Getting error in create blog", error);
  }
};

export const handleAdminGetBlogDetail = async (id) => {
  try {
    const response = await getMethod(`${ADMIN_BLOG_DETAIL}/${id}`);
    return response;
  } catch (error) {
    // console.error("Getting error in fetch blog detail", error);
  }
};

export const handleAdminUpdateBlog = async (id, data) => {
  try {
    const response = await putMethod(`${ADMIN_BLOG_UPDATE}/${id}`, data);
    return response;
  } catch (error) {
    // console.error("Getting error in update blog", error);
  }
};

export const handleAdminDeleteBlog = async (id) => {
  try {
    const response = await deleteMethod(`${ADMIN_BLOG_DELETE}/${id}`);
    return response;
  } catch (error) {
    // console.error("Getting error in delete blog", error);
  }
};
